// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__container___V0pFD {
    margin-bottom: var(--section-margin-bottom);
}

.styles__previewContainer___ofp5n {
    display: flex;
    flex-wrap: nowrap;
    margin: 0;
    padding: 0;
}

.styles__previewContainer___ofp5n li {
    list-style: none;
    border-radius: 12px;
    overflow: hidden;
}

.styles__previewContainer___ofp5n li img {
    display: block;
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../shared/components/PreviewScreenshots/styles.css"],"names":[],"mappings":"AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;AACf","sourcesContent":["@import \"../../styles/variables.css\";\n\n.container {\n    margin-bottom: var(--section-margin-bottom);\n}\n\n.previewContainer {\n    display: flex;\n    flex-wrap: nowrap;\n    margin: 0;\n    padding: 0;\n}\n\n.previewContainer li {\n    list-style: none;\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n.previewContainer li img {\n    display: block;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles__container___V0pFD`,
	"previewContainer": `styles__previewContainer___ofp5n`
};
export default ___CSS_LOADER_EXPORT___;
